import { render, staticRenderFns } from "./XXJGS_AddPage.vue?vue&type=template&id=61641620&scoped=true&"
import script from "./XXJGS_AddPage.vue?vue&type=script&lang=js&"
export * from "./XXJGS_AddPage.vue?vue&type=script&lang=js&"
import style0 from "./XXJGS_AddPage.vue?vue&type=style&index=0&id=61641620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61641620",
  null
  
)

export default component.exports